import React from 'react';
import PropTypes from 'prop-types';

class RecipientBuilderFinishModalBody extends React.Component {

  constructor() {
    super();
    this.finishAndClose = this.finishAndClose.bind(this);
  }

  finishAndClose() {
    window._track('Send Now | Recipient Builder', 'Recipient Builder');
    this.props.close();
    this.props.finish();
  }

  render() {
    return (
      <div className="self-serve-recipient-modal-body">
        <div className="modal-icon-wrapper">
          <img
            alt="mailbox icon"
            className="modal-icon"
            src="images/self-serve-recipient-builder/modals/mailbox-icon-2x.png"
          />
        </div>
        <div className="header">
          <p>You’re About to Send Your Document</p>
        </div>
        <div className="divider-wrapper">
          <div className="divider" />
        </div>
        <div className="recipient-builder-instructions-wrapper">
          <ul className="recipient-builder-instructions">
            <li>Once submitted, your responses can’t be edited.</li>
            <li>Print or download a copy for your records after you send.</li>
          </ul>
        </div>
        <div className="recipient-finish-button-wrapper">
          <button
            className="btn cancel-modal-button"
            onClick={this.props.close}
          >
            Cancel
          </button>
          <button
            className="close-modal-button finish-button"
            onClick={this.finishAndClose}
          >
            Send Now
          </button>
        </div>
      </div>
    );
  }
}

RecipientBuilderFinishModalBody.propTypes = {
  close: PropTypes.func.isRequired,
  finish: PropTypes.func.isRequired,
};

export default RecipientBuilderFinishModalBody;



// WEBPACK FOOTER //
// ./src-react/SelfServeModals/RecipientBuilderFinishModal/RecipientBuilderFinishModalBody.jsx